// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a2bd2648","455":"210d0082","946":"1c8a954e"}[chunkId] + ".chunk.js";
};